// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb_container__RG4Jb","item":"Breadcrumb_item__M5aUp","separator":"Breadcrumb_separator__RmZPG","active":"Breadcrumb_active__HIn+V"};